import { api } from '@api/api2';
import type { GetResidentObjectListPayload } from './types';

export const getResidentObjectList = (payload: GetResidentObjectListPayload) =>
  api.v4('get', 'residents-new/object/list', payload);
